
function userXTimestampHeader() {
    const timestamp = Date.now();
    digitalData.page.attributes.date.timestamp = timestamp;
    
    return {
        'x-timestamp': timestamp
    };
}

module.exports = {
    userXTimestampHeader
};
